const ButtonHeader = (props: any) => {
  let textButton = props.textButton ?? "";
  let icon = props.icon ?? "";
  let active = props.active || false;
  let className = props.className
    ? `${props.className} ${active ? "active" : ""}`
    : `btn btnHeader ${active ? "active" : ""}`;

  return (
    <button type="button" onClick={props.handleChange} className={className}>
      <span className="material-symbols-outlined">{icon}</span>
      {textButton}
    </button>
  );
};

export default ButtonHeader;
